// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1hur1","clinicsSelect":"TableHeading_clinicsSelect__1nldo"};